import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { finalize, iif } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'atm-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent {
  readonly environmentName = environment.name;

  form: FormGroup;
  passwordVisible = false;
  isLoading = false;

  showClassicalLogin = environment.name === 'Development';

  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogRef: MatDialog,
    @Inject(DOCUMENT) private document: any,
    fb: FormBuilder
  ) {
    console.log(environment.name)
    this.form = fb.group({
      login: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [true],
    });
    this.dialogRef.closeAll();
  }

  signIn(): void {
    const { login, password, rememberMe } = this.form.value;
    this.isLoading = true;

    iif(
      () => rememberMe,
      this.auth.signInAndRemember(login, password),
      this.auth.signIn(login, password)
    )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => this.router.navigate(['/']));
  }

  SSO(): void {
    this.isLoading = true;
    this.route.queryParamMap.subscribe((param) => {
      const returnUrl =
        param.get('returnUrl') ||
        encodeURI(`${this.document.location.origin}/dashboard`);

      this.auth.signSSO(returnUrl).subscribe();
    });
  }
}
